export default __webpack_public_path__ + "static/media/18.8fcf3d53.jpg";